// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-tab[data-v-ac7bd8d4]{border-radius:12px;color:#999;display:flex;flex-wrap:wrap;grid-gap:10px;gap:10px}.select-tab li[data-v-ac7bd8d4]{cursor:pointer;padding:3px 11px;box-sizing:content-box;font-size:12px;line-height:18px;font-weight:400;border-radius:13px;border:1px solid #bbb}.select-tab li.is-active[data-v-ac7bd8d4]{background:#386ff2;color:#fff;border:1px solid #fff;padding:4px 12px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
